import React, { useMemo, useState, useEffect } from 'react';
import moment from 'moment';
import { history, useSelector, useIntl } from 'umi';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import NoEntityCard from '@/pages/intelligence/pages/Compare/components/NoEntityCard';
import Filter from '../components/StoreRankFilter';
// import GameHeader from '@/pages/intelligence/pages/Compare/MobileGames/components/GameHeader';
import GameList from '@/pages/intelligence/pages/Compare/MobileGames/components/GameList';
import AddEntities from '../../components/AddEntities';
import EntityRenderer from '../EntityRenderer';
import Actionbar from '../../components/Actionbar';
import MetricTable from '../components/MetricTable/StoreRankMetricTable';
import CountriesTableMul from '../components/CountriesTableMul';
import MoreVisualis from '../components/MoreVisualis';
import usePlatformRegionsOptions from '@/pages/intelligence/hooks/usePlatformRegionsOptions';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { ComposedDateMode } from '@/pages/intelligence/components/ComposedDatePicker/enums';
import {
  fetchKeywords,
  fetchGamesByKeyword,
  fetchSimilarGames,
  addComparingGames,
  deleteComparingGames,
} from '@/pages/intelligence/pages/Compare/MobileGames/services';
import {
  getCompareStroeRank,
  getCompareStroeRankMul,
  fetchCompareMobileStoreRankCntTrends,
  fetchCompareMobileStoreRankMulCntTrends,
} from '@/pages/intelligence/services/mobileCompare';
import ExportTable from '@/pages/intelligence/components/ExportTable';

import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';

import { getDateTypeOfBackend } from '@/pages/intelligence/utils/common';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import {
  getGameTime,
  calMin,
  handleStoreRankMulListFormat,
  getPlatformByStoreNames,
  getDownloadDates,
  getOtherDateFormat,
  getIsRangeDayMonth,
  getMergedRegionsOptionsAndAllCountriesByStores,
} from '../utils';
import { getInitialFilterParams } from './utils';
import { MAXGAMENUM } from '../../constants';
import { COMPARE_MOBILE_SOURCES, DEFAULT_FILTER_PARAMS } from './config';
import { compareMobileGames } from '@intelligence/v3/constants/downloadLogPoint';

import type {
  IBaseProps,
  IGameType,
  IDateType,
  IDateValue,
  IRegion,
} from '@/pages/intelligence/types/common';

import type { IComposedDateData } from '@/pages/intelligence/components/ComposedDatePicker/types';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import { Button, Modal } from 'tea-component';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';

interface IMobileCompareStoreRankProps extends IBaseProps {
  entityType: IGameType;
  mainSegment: string;
  mainSegmentText: string;
}

const MobileCompareStoreRank: React.FC<IMobileCompareStoreRankProps> = (props) => {
  const { entityType, mainSegment, mainSegmentText } = props;
  const { formatMessage } = useIntl();
  const { isLoading: isRegionsOptionsLoading, regionsOptionsMap } = usePlatformRegionsOptions('', {
    entityType,
    platforms: COMPARE_MOBILE_SOURCES,
  });

  const { filterExtend } = useFilterExtend({});

  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: hasDataTimerParams?.compareMobileStoreRank?.type,
  });

  const filterState = useSelector((state: any) => state?.[FILTER_EXTEND_NAMESPACE] || {});
  const isOperate = filterState?.isOperate;

  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [noData, setNoData] = useState(false);
  const [gameList, setGameList] = useState<any[]>([]);
  const [titleDate, setTitleDate] = useState('');
  const [isShowRangeDayMonth, setIsShowRangeDayMonth] = useState(false);
  const [echartLoading, setEchartLoading] = useState(false);
  const [lineData, setLineData] = useState<any[]>([]);
  const [ClearVisible, setClearVisible] = useState(false);
  // 绝对时间 YYYY-MM-DD 这种格式 参数最外层的start_date、end_date
  const [absoluteDateValue, setAbsoluteDateValue] = useState<IDateValue>(['', '']);
  // 相对时间
  const [relativeDateValue, setRelativeDateValue] = useState<IDateValue>(['1', '30']);
  /** 组合时间筛选器部分 **/
  const [composedDateData, setComposedDateData] = useState<IComposedDateData>({
    mode: ComposedDateMode.Absolute,
    dateType: 'date',
    dateValue: [],
  });
  const handleComposeDateChange = (
    mode: ComposedDateMode,
    dateType: IDateType,
    dateValue: IDateValue,
  ) => {
    const composedDateDataTemp = {
      ...composedDateData,
      mode,
      dateType,
      dateValue,
    };
    setComposedDateData(composedDateDataTemp);
    if (mode === ComposedDateMode.Absolute) {
      setAbsoluteDateValue(dateValue);
      fetchCompareGameTrendsData(
        getChartApiData(apiData, false, dateType, dateValue),
        countryType,
        false,
      );
      return;
    }
    setRelativeDateValue(dateValue);
    fetchCompareGameTrendsData(
      getChartApiData(apiData, true, dateType, absoluteDateValue, dateValue),
      countryType,
      true,
    );
  };
  /** 组合时间筛选器部分 **/

  const echartDateType = useMemo(
    () => getOtherDateFormat(composedDateData?.dateType),
    [composedDateData?.dateType],
  );

  const initialFilterParams = getInitialFilterParams(
    isOperate,
    filterExtend,
    DEFAULT_FILTER_PARAMS,
  );
  const { regionsOptions: initialRegionsOptions, allCountries: initialAllCountries } = useMemo(
    () =>
      getMergedRegionsOptionsAndAllCountriesByStores(
        initialFilterParams?.dataSource,
        regionsOptionsMap,
      ),
    [initialFilterParams?.dataSource, regionsOptionsMap],
  );
  const [regionsOptions, setRegionsOptions] = useState<IRegion[]>([]);
  useEffect(() => {
    if (isRegionsOptionsLoading) return;
    setRegionsOptions(initialRegionsOptions);
  }, [isRegionsOptionsLoading]);
  const [heatMap, setHeatMap] = useState(initialFilterParams?.showHeatMap);
  const [countryType, setCountryType] = useState(initialFilterParams?.selectedType);
  const [apiData, setApiData] = useState({
    entity_type: entityType,
    region_type: 'market',
    regions: initialFilterParams.regionValue,
    data_sources: initialFilterParams?.dataSource,
    game_ids: [], // game_id为游戏id,查询用，
  });

  const [fetchParams, setFetchParams] = useState<any>({
    entity_type: entityType,
    region_type: 'market',
    regions: initialFilterParams?.regionValue,
    data_sources: initialFilterParams?.dataSource,
    game_ids: [], // game_id为游戏id,查询用，
    start_date: '',
    end_date: '',
    launch_date: 0,
  });

  const selectedPlatforms = useMemo(
    () => getPlatformByStoreNames(apiData?.data_sources),
    [apiData?.data_sources],
  );

  const gamesEntities = useMemo(() => {
    if (!Array.isArray(gameList)) return [];
    return gameList.map((item, index) => ({
      ...item,
      gameId: item?.game_id || '',
      gameName: item?.name || '',
      entityType: item?.entity_type || entityType,
      cover: item?.cover || '',
      publisher: item?.publisher || '',
      releaseTime: item?.release_time || '',
      sequence: item?.sequence || index + 1,
    }));
  }, [gameList]);

  const initCompare = async (initialAllCountries: string[]) => {
    setLoading(true);
    // 取继承国家的交集
    const filterMarkets = initialFilterParams?.regionValue?.filter((item) =>
      initialAllCountries?.includes(item),
    );
    const initialSelectedType = initialFilterParams?.selectedType;
    const initialRegions = isOperate ? filterMarkets : initialAllCountries;
    const _apiData = {
      ...apiData,
      regions: initialRegions,
    };
    const _fetchParams = {
      ...fetchParams,
      regions: initialRegions,
    };
    // 国家为空时，默认单选值或全选值
    if (!_fetchParams?.regions?.length) {
      _fetchParams.regions = initialSelectedType === 'single' ? ['us'] : initialAllCountries;
    }
    if (!_apiData?.regions?.length) {
      _apiData.regions = initialSelectedType === 'single' ? ['us'] : initialAllCountries;
    }
    // 值为global时，默认是全选值
    if (_fetchParams?.regions?.[0] === 'global') {
      _fetchParams.regions = initialAllCountries;
    }
    if (_apiData?.regions?.[0] === 'global') {
      _apiData.regions = initialAllCountries;
    }
    setApiData(_apiData);
    setFetchParams(_fetchParams);
    // 获取到国家全选值后再请求接口
    const { gameIds } = await getCompareMetricData(_apiData, initialSelectedType);
    fetchCompareGameTrendsData(
      getChartApiData({ ..._fetchParams, game_ids: gameIds }, false),
      initialSelectedType,
      false,
    );
  };

  // 首次进来先获取筛选器接口
  useEffect(() => {
    if (isRegionsOptionsLoading) return;
    initCompare(initialAllCountries);
  }, [isRegionsOptionsLoading]);

  const getCompareMetricData = async (
    _apiData: any,
    _countryType: 'multiple' | 'simple' | (string & {}),
  ) => {
    setLoading(true);
    setApiData(_apiData);
    const gameIds: any = [];
    try {
      const filterMarkets = initialFilterParams?.regionValue?.filter((item) =>
        initialAllCountries?.includes(item),
      );

      const res =
        _countryType === 'multiple'
          ? await getCompareStroeRankMul({ ..._apiData })
          : await getCompareStroeRank({ ..._apiData });
      const _gameList = res?.data?.compare_list;
      const _titleDate = res?.data?.last_date;
      setTitleDate(_titleDate ? moment(_titleDate)?.format('YYYY.MM.DD') : '-');
      if (Array.isArray(_gameList)) {
        const _calList = calMin(_gameList); // 这里多国家会在handleStoreRankMulListFormat里处理
        _gameList?.forEach((item) => {
          gameIds.push(item?.game_id);
        });
        setApiData({ ..._apiData, game_ids: gameIds });
        setGameList(_calList);
        setNoData(false);
      } else {
        setNoData(true);
        setGameList([]);
        resetHandle();
      }
    } catch (err) {
      console.log(err);
      setNoData(true);
      setGameList([]);
      resetHandle();
    }
    setLoading(false);
    return { gameIds };
  };

  const fetchCompareGameTrendsData = async (
    _apiData: any,
    _countryType = countryType,
    isRangeDayMonth: boolean,
  ) => {
    setEchartLoading(true);
    try {
      const res =
        _countryType === 'multiple'
          ? await fetchCompareMobileStoreRankMulCntTrends({ ..._apiData })
          : await fetchCompareMobileStoreRankCntTrends({ ..._apiData });

      const _gameList = res?.data?.rank_trends || [];
      // 绝对时间，回写时间范围，相对时间，不回写时间范围
      if (!isRangeDayMonth) {
        const startDate = res?.req?.start_date || '';
        const endDate = res?.req?.end_date || '';
        const dateValue = [startDate, endDate];
        setAbsoluteDateValue(dateValue);
        setComposedDateData({
          ...composedDateData,
          mode: ComposedDateMode.Absolute,
          dateValue,
        });
      }
      setLineData(_gameList);
      setIsShowRangeDayMonth(isRangeDayMonth);
    } catch (err) {
      setLineData([]);
    }
    setEchartLoading(false);
  };

  const handleAddGame = () => {
    setVisible(true);
  };

  const handleDelGame = async (gameId: string) => {
    // 调用后端删除接口
    const isok = await delGames([gameId]); // 没有游戏时做兼容
    if (!isok) {
      // maybe 网络出错
      return;
    }
    // 过滤掉删除的游戏
    const _gameIds: any = [];
    const filterList = gameList?.filter((item) => {
      if (item?.game_id !== gameId) {
        _gameIds.push(item.game_id);
      }
      return item?.game_id !== gameId;
    });
    setGameList(calMin(filterList));
    if (filterList?.length === 0) {
      setNoData(true);
      resetHandle();
    } else {
      const _apiData = { ...apiData };
      _apiData.game_ids = _gameIds;
      setApiData(_apiData); // 删除后给apiData的game_ids赋值
      // 处理删除后的拆线图数据
      const filterEchartList: any[] = [];
      lineData?.forEach((item) => {
        const _games = item?.games?.filter((t: any) => t?.game_id !== gameId);
        filterEchartList.push({
          ...item,
          games: _games,
        });
      });
      setLineData(filterEchartList);
    }
  };

  const delGames = async (ids: string[]) => {
    setLoading(true);
    try {
      await deleteComparingGames(ids);
      setLoading(false);
      return true;
    } catch (err) {
      setLoading(false);
      return false;
    }
  };

  const handleClearGame = async () => {
    const idList = gameList?.map(
      (item) => item?.game_id, // 删除用game_id
    );
    const isok = await delGames(idList);
    if (!isok) {
      // maybe 网络出错
      return;
    }
    // 清空   game_ids
    const _apiData = { ...apiData };
    _apiData.game_ids = [];
    setApiData(_apiData);
    setGameList([]);
    setNoData(true);
  };

  const handleCompareConfirm = async (gameIds: string[], games: any[]) => {
    if (!gameIds?.length || !games?.length) return;
    try {
      await addComparingGames(games);
      setVisible(false);
    } catch (e) {
      console.warn(e);
      // 添加数据失败
      setVisible(false);
      return;
    }
    const _apiData: any = { ...apiData };
    _apiData.game_ids = gameIds;
    getCompareMetricData(_apiData, countryType);
    const isRangeDayMonth = getIsRangeDayMonth(composedDateData?.mode);
    fetchCompareGameTrendsData(
      getChartApiData(_apiData, isRangeDayMonth),
      countryType,
      isRangeDayMonth,
    );
  };

  const handleCompareCancel = () => {
    setVisible(false);
  };

  const handleConfirm = (values: any) => {
    const _apiData = {
      ...apiData,
      regions: values.regionValue?.length ? values.regionValue : apiData?.regions,
      data_sources: values.dataSource,
    };
    setCountryType(values.selectedType);
    setHeatMap(values.showHeatMap);
    setApiData(_apiData);
    if (loading || gameList?.length === 0) {
      return;
    }
    getCompareMetricData(_apiData, values.selectedType);
    const isRangeDayMonth = getIsRangeDayMonth(composedDateData?.mode);
    fetchCompareGameTrendsData(
      getChartApiData(_apiData, isRangeDayMonth),
      values.selectedType,
      isRangeDayMonth,
    );
  };

  const getChartApiData = (
    apiData: any,
    isRangeDayMonth: boolean,
    dateType = composedDateData?.dateType,
    dateValue = absoluteDateValue,
    rangeValue = relativeDateValue,
  ) => {
    let apiDataObj = apiData;
    const otherDateType = getOtherDateFormat(dateType);
    const idList = [];
    for (const n in apiDataObj.game_ids) {
      const obj = {
        game_id: apiDataObj.game_ids[n],
        start_date: isRangeDayMonth
          ? getGameTime(gameList, 'start_date', apiDataObj.game_ids[n], otherDateType, rangeValue)
          : '',
        end_date: isRangeDayMonth
          ? getGameTime(gameList, 'end_date', apiDataObj.game_ids[n], otherDateType, rangeValue)
          : '',
      };
      idList.push(obj);
    }
    apiDataObj = { ...apiData, game_ids: idList };

    const _lineApi = {
      ...apiDataObj,
      start_date: !isRangeDayMonth ? dateValue[0] : '',
      end_date: !isRangeDayMonth ? dateValue[1] : '',
      period: otherDateType?.toLocaleLowerCase(),
      launch_date: !isRangeDayMonth ? 0 : (rangeValue?.[0] as any) * 1,
    };
    setFetchParams(_lineApi);
    return _lineApi;
  };

  const resetHandle = () => {
    const dateValue = [
      moment().subtract(30, 'd').format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD'),
    ];
    setIsShowRangeDayMonth(false);
    setAbsoluteDateValue(dateValue);
    setComposedDateData({
      ...composedDateData,
      mode: ComposedDateMode.Absolute,
      // dateValue,
      dateValue:
        [
          moment(latestTimeTypeHasData?.date?.[0])?.format('YYYY-MM-DD'),
          moment(latestTimeTypeHasData?.date?.[1])?.format('YYYY-MM-DD'),
        ] || [],
    });
  };

  const getDetailPath = (gameId: string): string => {
    const path = getDetailGamePathCommon({
      entityType,
      gameId,
      tab: 'storerank',
      subTab: '',
    });
    return path || '';
  };
  const handleGoDetail = (gameId: string) => {
    history.push(getDetailPath(gameId));
  };

  const isLoadingTotal = isRegionsOptionsLoading || loading;

  return (
    <div className="dbi-compare-mobile_storerank">
      <Filter
        isOperate={isOperate}
        dataSource={apiData?.data_sources}
        regionsOptionsMap={regionsOptionsMap}
        regionsOptions={regionsOptions}
        setRegionsOptions={setRegionsOptions}
        allCountries={initialAllCountries}
        onConfirm={handleConfirm}
        onReset={resetHandle}
      />
      {/* 加载动画 */}
      {isLoadingTotal && (
        <>
          <Abnormal
            style={{
              // margin: '0 0 64px 0',
              margin: '0 0 20px 0',
              height: 482,
              backgroundColor: '#fff',
              borderRadius: 8,
            }}
            isLoading={true}
          />
          <Abnormal
            style={{ height: 400, backgroundColor: '#fff', borderRadius: 8 }}
            isLoading={true}
          />
        </>
      )}

      {isLoadingTotal || (
        <div className="dbi-compare-mobile-content">
          {/* 无数据 */}
          {noData && <NoEntityCard onAdd={handleAddGame} />}
          {noData || (
            <CardSlotV2
              rightDom={
                <Button
                  type="link"
                  onClick={() => {
                    setClearVisible(true);
                  }}
                >
                  {formatMessage({ id: 'dbi_clear_all' })}
                </Button>
              }
              IconList={false}
              title={formatMessage({
                id: 'dbi_compare_mobile_current_store_rank',
              })}
            >
              <div className="dbi-compare-mobile-content">
                {/* <GameHeader
                title={formatMessage({ id: 'dbi_compare_mobile_current_store_rank' })}
                subTitle={formatMessage({ id: 'dbi_compare_select_games_limit_tips' }, { max: MAXGAMENUM })}
                operation={formatMessage({ id: 'dbi_clear_all' })}
                handleOperation={handleClearGame}
                showSubTitle={gameList?.length >= MAXGAMENUM}
              /> */}
                <GameList
                  entityType={entityType}
                  list={gameList}
                  handleAdd={handleAddGame}
                  handleDel={handleDelGame}
                  handleGoDetail={handleGoDetail}
                  getDetailPath={getDetailPath}
                  showAddGame={gameList?.length < MAXGAMENUM}
                />

                <div className="dbi-compare-mobile-bar">
                  <span className="dbi-compare-mobile__keymetric-title">
                    {countryType === 'multiple'
                      ? formatMessage({ id: 'dbi_compare_mobile_countries_counts' })
                      : formatMessage({ id: 'dbi_compare_mobile_current_rank' })}
                  </span>
                  <span className="dbi-compare-mobile__keymetric-time">({titleDate})</span>
                </div>

                {countryType === 'multiple' ? (
                  <CountriesTableMul
                    MAXGAMENUM={MAXGAMENUM}
                    list={handleStoreRankMulListFormat(gameList)}
                    showHeatMap={heatMap}
                    cloumnsLen={gameList?.length || 0}
                  />
                ) : (
                  <MetricTable
                    entityType={entityType}
                    MAXGAMENUM={MAXGAMENUM}
                    list={gameList}
                    showHeatMap={heatMap}
                    dataSource={apiData.data_sources}
                  />
                )}

                <Actionbar
                  disabled={echartLoading}
                  dateTypes={['date']}
                  // @ts-ignore
                  rangePickerProps={{
                    hiddenHeaderBtns: ['All of time'],
                    defaultValue: latestTimeTypeHasData,
                  }}
                  composedDateData={composedDateData}
                  onComposedPickerChange={handleComposeDateChange}
                  downloadNodeRenderer={() => (
                    <ExportTable
                      entityType={entityType}
                      businessType="compare-mobile-store-rank"
                      downloadModalSize="l"
                      excelName={mainSegmentText}
                      isDisableDownload={isLoadingTotal}
                      isOnlyExportAllData={true}
                      total={gameList?.length}
                      downloadLogConfigKey={compareMobileGames?.[`${entityType}_storeRank`]}
                      tableParams={{
                        ...apiData,
                        // source: apiData?.data_sources,
                        app_ids: apiData?.game_ids,
                        date_type: getDateTypeOfBackend(echartDateType as any),
                        start_date: absoluteDateValue?.[0] || '',
                        end_date: absoluteDateValue?.[1] || '',
                        compare_is_launch_date:
                          composedDateData?.mode === ComposedDateMode.Relative,
                        compare_download_date: getDownloadDates(
                          gameList,
                          composedDateData?.mode === ComposedDateMode.Relative,
                          getOtherDateFormat(composedDateData?.dateType),
                          relativeDateValue,
                        ),
                      }}
                    />
                  )}
                />
                <MoreVisualis
                  isLoading={echartLoading}
                  entityType={entityType}
                  chartType={ChartType.Line}
                  isRangeDayMonth={isShowRangeDayMonth}
                  sources={apiData?.data_sources}
                  dateType={composedDateData?.dateType}
                  countryType={countryType}
                  lineDatas={lineData}
                />
              </div>
            </CardSlotV2>
          )}
        </div>
      )}

      {/* 添加游戏弹窗 */}
      <AddEntities
        entityKey="gameId"
        entities={gamesEntities}
        visible={visible}
        entityRenderer={EntityRenderer}
        keywordsFetcher={fetchKeywords}
        entitiesFetcher={fetchGamesByKeyword}
        similarEntitiesFetcher={fetchSimilarGames}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onConfirm={handleCompareConfirm}
        onClose={handleCompareCancel}
      />
      {ClearVisible && (
        <Modal
          size={500}
          visible={ClearVisible}
          // caption={formatMessage({ id: 'dbi_compare_clear_all' })}
          onClose={() => {
            setClearVisible(false);
          }}
        >
          <Modal.Body>
            <div className="dbi-compare-modal-context">
              {formatMessage({ id: 'dbi_compare_clear_all_confirm_tips' })}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="primary"
              onClick={() => {
                setClearVisible(false);
                handleClearGame();
              }}
            >
              {formatMessage({ id: 'dbi_confirm' })}
            </Button>
            <Button
              type="weak"
              onClick={() => {
                setClearVisible(false);
              }}
            >
              {formatMessage({ id: 'dbi_cancel' })}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default MobileCompareStoreRank;
